import { render } from "./PageFooter.vue?vue&type=template&id=0b2973f6&scoped=true&ts=true"
import script from "./PageFooter.vue?vue&type=script&lang=ts"
export * from "./PageFooter.vue?vue&type=script&lang=ts"

import "./PageFooter.vue?vue&type=style&index=0&id=0b2973f6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.3.0_webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b2973f6"]])

export default __exports__